import React, { forwardRef } from 'react';
import * as styles from './index.module.less';
import { IDropdownListItem } from '@/layout/constants';
import NavTitle from '@/components/heading/NavTitle';
import NavCardItem from '../nav-card-item';

interface IProps {
  data: IDropdownListItem[];
  className?: string;
  id?: string;
}

const DropdownContainer = forwardRef((props: IProps, ref: any) => {
  const { data, className = '', id } = props;
  return (
    <div className={`${styles.wrapper} ${className}`} id={id} ref={ref}>
      <div className={styles.inner}>
        {data.map((item, index) => {
          return (
            <div
              key={index}
              className={`${styles.nav_title_cards_container} ${
                !item.title && styles.nav_title_cards_container_without_border
              }`}
            >
              {item.title && <NavTitle style={{ color: '#4F5964' }}>{item.title}</NavTitle>}
              <div
                className={`${styles.nav_list_container} ${
                  !item.title && item.navItemList.length <= 3 && styles.stretch
                }`}
              >
                {item.navItemList.map((item, index) => {
                  return <NavCardItem key={index} data={item} />;
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});
export default DropdownContainer;
